import { extend } from 'vee-validate'
import { confirmed, email, image, max, min, required, size } from 'vee-validate/dist/rules'

extend('confirmed', {
  ...confirmed,
  message: 'The {_field_} does not match.',
});

extend('email', email);

extend('image', image);

extend('max', {
  ...max,
  message: '{_field_} must be less than {length} characters.',
});

extend('min', {
  ...min,
  message: '{_field_} must be at least {length} characters.',
});

extend('required', {
  ...required,
  message: '{_field_} is required.',
});

extend('size', size);

extend('strong_password', {
  message: field => 'Password needs letter, number, and specials (!@#$%^&*)',
  validate: value => {
    const regex = new RegExp("^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
    return regex.test(value);
  },
});

export default { confirmed, email, image, max, min, required, size };
